import { ArticleType } from '@wix/answers-api';
import { useRouter } from 'next/router';

import {
  HELPMATE_SUPPORTED_LANGUAGES,
} from '../constants';
import { useResponsive } from './useResponsive';
import { PageType } from '../types';
import { isTwinsRelated, isWixelRelated } from '../utils/excluded-categories';
import { useStore } from '../zustand/stores';

const useIsHelpCenterCopilotEnabled = () => {
  const { article } = useStore((state) => state.articleSlice);
  const itemId = useStore((state) => state.pageSlice.itemId);
  const categoriesTree = useStore(
    (state) => state.categoriesTreeSlice.categoriesTree
  );
  const { locale } = useRouter();
  const { isMobile, isTablet } = useResponsive();

  if (
    !isMobile &&
    !isTablet &&
    !article?.title?.includes('Wix Twins') &&
    article?.type === ArticleType.ARTICLE &&
    !isTwinsRelated(
      PageType.Article,
      categoriesTree,
      itemId,
      article?.categoryId
    ) &&
    !isWixelRelated(
      PageType.Article,
      categoriesTree,
      itemId,
      article?.categoryId
    ) &&
    (HELPMATE_SUPPORTED_LANGUAGES.includes(locale as string))
  ) {
    return true;
  }
  return false;
};

export default useIsHelpCenterCopilotEnabled;
